import React, { } from "react";
import { Treemap } from "@ant-design/plots";

const TreemapChart = React.forwardRef(({
    onload = () => { },
    onClickTile = () => { },
    customColor = false,
    data = [],
    config = {},
    height = "100%", width = "100%",
    children
}, ref) => {
    const chartConfig = {
        data: {
            name: "root",
            children: data
        },
        colorField: "color",
        autoFit: true,
        onReady: (graph) => {
            graph.on("element:click", (...args) => {
                onClickTile(args);
            });
            onload()
        },
        legend: false,
        ...config
    };
    if (customColor) {
        chartConfig.color = ({ color }) => color;
    }
    return (
        <div ref={ref} style={{ height, width }}>
            <Treemap {...chartConfig} >
                {children}
            </Treemap>
        </div>
    );
})

export default TreemapChart;
